import { createAction, props } from '@ngrx/store';
import { ISettingPlansState } from './setting-plans.state';

export const initSettingPlansAction = createAction('[popup SettingPlans] popup SettingPlans');

export const setSettingPlansAction = createAction(
  '[popup SettingPlans] set data',
  props<ISettingPlansState>()
);
